module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_kimono_collection-13c50763718fa6416c4e082000bbb4d8.jpg";